<template>
  <div>
    <b-row class='mb-3 mt-5'>
      <b-col cols="12">
        <b-button-group>
          <b-button
            variant='outline-primary'
            @click='() => addCategoryModal = true'
          >
            Dodaj kategorię
          </b-button>
          <b-button
            variant='outline-primary'
            @click='() => addMarkerModal = true'
          >
            Dodaj marker
          </b-button>
        </b-button-group>
      </b-col>
    </b-row>

  <label class='mt-3'>Punkt startowy mapy</label>
  <b-card class='mt-2'>
    <b-row>
      <b-col cols="6">
        <label>Latitude</label>
        <b-form-input
          v-model="form.doc.map.startingPoint.lat"
        />
      </b-col>
      <b-col cols="6">
        <label>Longitude</label>
        <b-form-input
          v-model="form.doc.map.startingPoint.lon"
        />
      </b-col>
    </b-row>
  </b-card>

  <label class='mt-3'>Kategorie</label>
  <b-card class='mt-2'>

    <b-modal
      v-if='removeCategoryModal'
      v-model='removeCategoryModal'
      ok-title="Tak"
      cancel-title="Nie"
      @ok='() => actions.handleRemoveMarkerCategory(itemToRemove)'
      centered
    >
      Czy usunąć kategorię <i>{{ itemToRemove.name['pl'] }}</i> wraz z markerami ?
    </b-modal>

    <b-modal
      v-if='removeMarkerModal'
      v-model='removeMarkerModal'
      ok-title="Tak"
      cancel-title="Nie"
      @ok='() => actions.handleRemoveMarker(itemToRemove)'
      centered
    >
      Czy usunąć marker <i>{{ itemToRemove.name['pl'] }}</i> ?
    </b-modal>

    <b-modal
      v-if='addCategoryModal'
      v-model='addCategoryModal'
      ok-title="Tak"
      cancel-title="Nie"
      @ok='() => handleAddCategory()'
      centered
    >
      <b-row>
        <b-col cols="6" v-for='(locale, i) in locales' :key='i' class='mb-3'>
          <div>
            <label>Nazwa {{ locale }}</label>
            <b-form-input
              v-model="categoryName[locale]"
            />
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      v-if='addMarkerModal'
      v-model='addMarkerModal'
      ok-title="Tak"
      cancel-title="Nie"
      @ok='() => handleAddMarker()'
      centered
    >
      <div>
        <b-row>
          <b-col cols="12">
            <label>Wybierz kategorię</label>
            <b-form-select
              class='form-control'
              :options="categories.map((c) => ({value: c.id, text: c.name.pl}))"
              @input='(e) => markerCategoryId = e'
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6" v-for='(locale, i) in locales' :key='i' class='mb-3'>
            <div>
              <label>Nazwa {{ locale }}</label>
              <b-form-input
                v-model="markerName[locale]"
              />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <label>Latitude</label>
            <b-form-input
              v-model="markerLat"
            />
          </b-col>
          <b-col cols="6">
            <label>Longitude</label>
            <b-form-input
              v-model="markerLon"
            />
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-row class='mb-3'>
      <b-col cols="12">
        <b-row v-for='(category, i) in categories' :key='i' class='mb-3'>
          <b-col cols="1">
            #{{ category.id }}
          </b-col>
          <b-col cols="4" v-for='(locale, i) in locales' :key='i'>
            <label>Nazwa {{ locale }}</label>
            <b-form-input 
              v-model="category.name[locale]"
            />
          </b-col>
    
          <b-col cols="2">
            <label>Kolor markerów</label>
            <b-form-input
              type='color'
              v-model="category.color"
            />
          </b-col>

          <b-col cols="1" class="pt-3 mt-3">
            <b-button title="Usuń kategorię" variant="danger" size='sm' @click='() => { itemToRemove = category; removeCategoryModal = true; }'>
              <b-icon-trash />
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    
  </b-card>

  <label class='mt-3'>Markery</label>
  <b-card class='mt-2' v-for='(marker, i) in markers' :key='i'>
    <b-row class='mb-3'>
      <b-col cols="12">
        <b-button class="float-right" title="Usuń marker" variant="danger" size='sm' @click='() => { itemToRemove = marker; removeMarkerModal = true; }'>
          <b-icon-trash />
        </b-button>
      </b-col>
    </b-row>

    <b-row class='mb-3'>
      <b-col cols="12">
        <b-row  class='mb-3'>
          <b-col cols="6" v-for='(locale, i) in locales' :key='i'>
            <label>Nazwa {{ locale }}</label>
            <b-form-input 
              v-model="marker.name[locale]"
            />
          </b-col>
        
          <b-col cols="4" class='mt-3'>
            <label>Kategoria</label>
            <b-form-select
              class='form-control'
              :options="categories.map((c) => ({value: c.id, text: c.name.pl}))"
              v-model="marker.categoryId"
            />
          </b-col>
          <b-col cols="4" class='mt-3'>
            <label>Latitude</label>
            <b-form-input 
              v-model="marker.lat"
            />
          </b-col>
          <b-col cols="4" class='mt-3'>
            <label>Longitude</label>
            <b-form-input 
              v-model="marker.lon"
            />
          </b-col>
        </b-row>
        <b-row  class='mb-3'>
          <b-col cols="4" class='mt-3'>
            <label>Opis pl</label>
            <b-form-textarea 
              v-model="marker.desc"
              rows='3'
              max-rows='6'
            />
          </b-col>
          <b-col cols="4" class='mt-3'>
            <label>Opis en</label>
            <b-form-textarea 
              v-model="marker.desc_en"
              rows='3'
              max-rows='6'
            />
          </b-col>
          <b-col cols="4" class='mt-3'>
            <label>Scena</label>
            <b-form-select
              class='form-control'
              :options="scenes.map((c) => ({value: c.id, text: c.name.pl}))"
              v-model="marker.sceneId"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-card>
  </div>
</template>

<script>
  import { LOCALES } from '@/const'
  import {
    handleSimplePropChanged,
    handleSimplePropWithLocaleChanged,
    handleNestedPropChanged,
    handleEventPropChanged,
    handleAddMarkersCategory,
    handleAddMarker,
    handleRemoveMarker,
    handleRemoveMarkerCategory,
    //handleEditMarker,
    //handleEditMarkerCategory,
  } from '@/store/utils'

  import {
    BIconTrash,
  } from 'bootstrap-vue'
  
  export default {
    components: {
      BIconTrash,
    },
    data() {
      return {
        locales: LOCALES,
        addCategoryModal: false,
        addMarkerModal: false,
        removeMarkerModal: false,
        removeCategoryModal: false,
        itemToRemove: null,
        categoryName: { pl: '', en: '' },
        markerName: { pl: '', en: '' },
        markerCategoryId: null,
        markerLat: null,
        markerLon: null,
        actions: {
          handleSimplePropChanged,
          handleSimplePropWithLocaleChanged,
          handleNestedPropChanged,
          handleEventPropChanged,
          handleAddMarkersCategory,
          handleAddMarker,
          handleRemoveMarker,
          handleRemoveMarkerCategory,
          //handleEditMarker,
          //handleEditMarkerCategory,
        },
      }
    },
    methods: {
      handleAddCategory() {
        this.actions.handleAddMarkersCategory({...this.categoryName})
      },
      handleAddMarker() {
        this.actions.handleAddMarker(
          this.markerName,
          this.markerCategoryId,
          this.markerLat,
          this.markerLon,
        )
      }
    },
    computed: {
      scenes() {
        try {
          return [...this.$store.state.fanzones.form.doc.scenesData.scenes]
        } catch {
          return []
        }
      },
      categories() {
        try {
          return this.$store.state.fanzones.form.doc.map.markersCategories;
        } catch {
          return [];
        }
      },
      markers() {
        try {
          return this.$store.state.fanzones.form.doc.map.markers;
        } catch {
          return [];
        }
      },
      form() {
        return this.$store.state.fanzones.form
      }
    },
  }
</script>